import { MealsPlanPage } from './MealsPlanPage';

export const mealsPlanRoutes = [
  {
    path: '',
    element: <MealsPlanPage />,
  },
];
